var _path;
import * as React from "react";
function SvgShot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 4,10.344 H 20 L 18,24 H 6 Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShot);
export default __webpack_public_path__ + "static/media/Shot.d11b899163e72e6e30b96e96b81a8e73.svg";
export { ForwardRef as ReactComponent };